import { Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatPaginator, PageEvent } from "@angular/material/paginator";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ActivatedRoute, Router } from "@angular/router";
import { AdminService } from "src/app/injectable/admin.service";
import { GenericErrorModalService } from "src/app/injectable/generic-error-handling/generic-error-modal.service";
import { Pageable2 } from "src/app/model/pageable2";
import { PaginatorConfig } from "src/app/model/paginatorConfig";
import { Sender } from "src/app/model/sender";
import { EditSenderDialogComponent } from "../client-detail/edit-sender-dialog/edit-sender-dialog.component";
import { DeleteUserDialogComponent } from "./delete-user-dialog/delete-user-dialog.component";
import { EnableDisableUserDialogComponent } from "./enable-disable-user-dialog/enable-disable-user-dialog.component";
import { InsertUserDialogComponent } from "./insert-user-dialog/insert-user-dialog.component";
import { ModifyUserDialogComponent } from "./modify-user-dialog/modify-user-dialog.component";
import { ModifyUserSendersDialogComponent } from "./modify-user-senders-dialog/modify-user-senders-dialog.component";
import { UserInsertRequest } from "./user-insert-request";
import { UserModifyRequest } from "./user-modify-request";
import { UserModifySendersRequest } from "./user-modify-senders-request";

@Component({
  selector: "app-show-users",
  templateUrl: "./show-users.component.html",
  styleUrls: ["./show-users.component.scss"],
})
export class ShowUsersComponent implements OnInit {
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild("paginator") paginator: MatPaginator;
  loading = false;
  sub = false;
  emptyList = false;
  // displayedColumns = ['nameUser', 'description', 'email', 'actions'];
  displayedColumns = ["username", "role", "email", "actions"];
  dataSource: MatTableDataSource<any>;
  pageable: Pageable2 = new Pageable2();
  paginatorConfig: PaginatorConfig;
  filterValue = "";
  totalElements: number;

  constructor(
    private adminService: AdminService,
    private router: Router,
    private route: ActivatedRoute,
    public dialog: MatDialog,
    private snackBar: MatSnackBar,
    private genericErrorModalService: GenericErrorModalService
  ) {}

  ngOnInit(): void {
    this.paginatorConfig = new PaginatorConfig();
    if (sessionStorage.getItem("userSort") != null) {
      let tmpfilterconfig = JSON.parse(sessionStorage.getItem("userSort"));
      this.paginatorConfig.setFilterColumn(tmpfilterconfig["active"]);
      this.paginatorConfig.setFilterDirection(tmpfilterconfig["direction"]);
    } else {
      this.paginatorConfig.filterColumn = "username";
    }
    this.pageable = {
      pageable: {
        pageNum: this.paginatorConfig.getPageNum(),
        pageSize: this.paginatorConfig.getPageSize(),
      },
      sort: {
        column: this.paginatorConfig.getFilterColumn(),
        direction: this.paginatorConfig.getFilterDirection(),
      },
      filter: {
        columns: ["username", "email"],
        value: "",
      },
    };
    if (sessionStorage.getItem("latestFilterValueUsers") != null) {
      this.filterValue = sessionStorage.getItem("latestFilterValueUsers");
      this.pageable.filter.value = this.filterValue;
    }

    if (sessionStorage.getItem("latestPageUsers") != null) {
      try {
        this.pageable.pageable.pageNum = Number(
          sessionStorage.getItem("latestPageUsers")
        );
      } catch (e) {}
    }

    this.getUsers();
  }

  onPagination(event: PageEvent) {
    this.pageable.pageable = {
      pageNum: event.pageIndex,
      pageSize: event.pageSize,
    };
    sessionStorage.setItem("latestPageUsers", event.pageIndex.toString());
    this.getUsers();
  }

  onSortChange(sort) {
    sessionStorage.setItem("userSort", JSON.stringify(sort));
    switch (sort.active) {
      case "username": {
        this.pageable.pageable.pageNum = 0;
        this.pageable.sort.column = "username";
        this.pageable.sort.direction = sort.direction.toUpperCase();
        this.getUsers();
        break;
      }
      case "email": {
        this.pageable.pageable.pageNum = 0;
        this.pageable.sort.column = "email";
        this.pageable.sort.direction = sort.direction.toUpperCase();
        this.getUsers();
        break;
      }
      default: {
        break;
      }
    }
  }

  getUsers() {
    this.loading = true;
    this.adminService.getUsers(this.pageable).subscribe(
      (value) => {
        this.loading = false;
        const list = value.list;
        this.totalElements = value.totalElements;
        if (list.length == 0) {
          this.emptyList = true;
        } else {
          this.emptyList = false;
        }
        this.dataSource = new MatTableDataSource<any>();
        // this.dataSource.sort = this.sort;
        // this.dataSource.sortingDataAccessor = (item, property) => {
        //   switch (property) {
        //     case 'nameUser': {
        //       return item.nameUser.toLowerCase();
        //     }
        //     case 'description': {
        //       return item.role.description.toLowerCase();
        //     }
        //     case 'email': {
        //       return item.emailUser.toLowerCase();
        //     }
        //     default: {
        //       return item[property];
        //     }
        //   }
        // };
        this.dataSource.data = list;
      },
      (error) => {
        this.loading = false;
        console.error(error);
        this.genericErrorModalService.open(
          "Errore nel caricamento della lista degli Users",
          error
        );
      }
    );
  }

  insertUserDialog() {
    let userInsertRequest: UserInsertRequest;
    const dialogRef = this.dialog.open(InsertUserDialogComponent);
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        userInsertRequest = result;
        this.sub = true;
        this.adminService.insertUser(userInsertRequest).subscribe(
          (res) => {
            this.sub = false;
            this.getUsers(); // Riottiene gli utenti compreso il nuovo inserimento
            this.openSnackBar("Utente inserito con successo.", "Chiudi");
          },
          (err) => {
            console.error("Errore nell'inserimento dello User.", err);
            this.genericErrorModalService.open(
              "Errore durante l'inserimento dello User",
              err
            );
            this.sub = false;
          }
        );
      }
    });
  }

  onUserDetails(user) {
    // this.router.navigate([user.idUser], { relativeTo: this.route });
    let userModifyRequest: UserModifyRequest;
    const dialogRef = this.dialog.open(ModifyUserDialogComponent, {
      data: {
        user,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        userModifyRequest = result;
        this.sub = true;
        this.adminService.modifyUser(userModifyRequest).subscribe(
          (res) => {
            this.sub = false;
            this.getUsers(); // Riottiene gli utenti
            this.openSnackBar("Utente modificato con successo.", "Chiudi");
          },
          (err) => {
            console.error("Errore nella modifica dello User.", err);
            this.genericErrorModalService.open(
              "Errore durante la modifica dello User",
              err
            );
            this.sub = false;
          }
        );
      }
    });
  }

  onUserDisable(user) {
    if (user.enabled) {
      const dialogRef = this.dialog.open(EnableDisableUserDialogComponent, {
        data: { user },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          const userDisableRequest = {
            idUser: user.id,
            username: user.username,
          };
          this.sub = true;
          this.adminService.disableUser(userDisableRequest).subscribe(
            (res) => {
              this.sub = false;
              this.getUsers(); // Riottiene gli utenti
              this.openSnackBar("User disabilitato con successo.", "Chiudi");
            },
            (err) => {
              console.error("Errore nella disabilitazione dello User.", err);
              this.genericErrorModalService.open(
                "Errore nella disabilitazione dello User",
                err
              );
              this.sub = false;
            }
          );
        }
      });
    } else {
    }
  }

  onUserEnable(user) {
    if (!user.enabled) {
      const dialogRef = this.dialog.open(EnableDisableUserDialogComponent, {
        data: {
          user,
          enabling: true,
        },
      });
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          const userDisableRequest = {
            idUser: user.id,
            username: user.username,
          };
          this.sub = true;
          this.adminService.enableUser(userDisableRequest).subscribe(
            (res) => {
              this.sub = false;
              this.getUsers(); // Riottiene gli utenti
              this.openSnackBar("User abilitato con successo.", "Chiudi");
            },
            (err) => {
              console.error("Errore nell'abilitazione dello User.", err);
              this.genericErrorModalService.open(
                "Errore nell'abilitazione dello User",
                err
              );
              this.sub = false;
            }
          );
        }
      });
    } else {
    }
  }

  onUserDelete(user) {
    const dialogRef = this.dialog.open(DeleteUserDialogComponent, {
      data: { user },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.sub = true;
        this.adminService.deleteUser(user.id).subscribe(
          (res) => {
            this.sub = false;
            this.getUsers(); // Riottiene gli utenti
            this.openSnackBar("User eliminato con successo.", "Chiudi");
          },
          (err) => {
            console.error("Errore nell'eliminazione dello User.", err);
            this.genericErrorModalService.open(
              "Errore nell'eliminazione dello User",
              err
            );
            this.sub = false;
          }
        );
      }
    });
  }

  onUserAssociations(user) {
    // this.router.navigate([user.idUser], { relativeTo: this.route });
    let userModifySendersRequest: UserModifySendersRequest;
    const dialogRef = this.dialog.open(ModifyUserSendersDialogComponent, {
      data: { user },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        userModifySendersRequest = result;
        this.sub = true;
        this.adminService.modifyUserSenders(userModifySendersRequest).subscribe(
          (res) => {
            this.openSnackBar(
              "Mittenti dello User modificati con successo.",
              "Chiudi"
            );
            this.sub = false;
            // this.getUsers() // Riottiene gli utenti compreso il nuovo inserimento
          },
          (err) => {
            console.error(
              "Errore nella modifica dei Mittenti dello User.",
              err
            );
            this.genericErrorModalService.open(
              "Errore durante la modifica dello User",
              err
            );
            this.sub = false;
          }
        );
      }
    });
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 3500,
      panelClass: "custom-snackbar",
    });
  }

  onFilterClear() {
    this.filterValue = "";
  }

  onFiltering() {
    this.pageable.filter.value = this.filterValue;
    this.paginator.firstPage();
    sessionStorage.setItem("latestFilterValueUsers", this.filterValue);
    // this.dataSource.filter = this.filterValue.trim().toLowerCase();
    this.getUsers();
  }

  onSearchKeydown(event) {
    if (event.key === "Enter") {
      if (this.filterValue.length == 0 || this.filterValue.length > 3) {
        this.paginator.firstPage();
        this.pageable.filter.value = this.filterValue;
        sessionStorage.setItem("latestFilterValueUsers", this.filterValue);
        // this.dataSource.filter = this.filterValue.trim().toLowerCase();
        this.getUsers();
      }
    }
  }
}
